import React, {useState} from 'react';
import Poll from './Poll';
import PollProgress from './PollProgress';
import questions from '../../data/questions';
import {Category, Question} from '../../types/questions';
import { ContainerMain } from '../../styles/global.style';

export default function PollStepper() {
  const categories = Object.entries(questions) as [Category, Question[]][];
  const totalSteps = categories.length;

  const [currentStep, setCurrentStep] = useState<number>(0);

  const [category, qList] = categories[currentStep];

  const handleNext = () => {
    if (currentStep < totalSteps - 1) setCurrentStep((i) => i + 1);
  };

  const handleBack = () => {
    if (currentStep > 0) setCurrentStep((i) => i - 1);
  };

  return (
    <ContainerMain>
      <Poll category={category} questions={qList} />
      <PollProgress
        category={category}
        currentStep={currentStep}
        totalSteps={totalSteps}
        onNext={handleNext}
        onBack={handleBack}
      />
    </ContainerMain>
  );
}
